import React from "react";

export function GemArt() {
  return <svg className="art" viewBox="0 0 80 80" aria-hidden="true">
    <path d="m13 27 13-15h28l13 15-27 40Z" fill="#00b82c" />
    <path d="m13 27 13-15h28l13 15Z" fill="#56f581" />
    <path d="m13 27 27 40-12-40Z" fill="#00db38" />
    <path d="m28 27 12 40 12-40Z" fill="#00f444" />
    <path d="m52 27-12 40 27-40Z" fill="#009e27" />
    <path d="m26 12 2 15 12-15Z" fill="#a3ffba" />
    <path d="m40 12-12 15h24Z" fill="#50fa7c" />
    <path d="m40 12 12 15 2-15Z" fill="#22dc59" />
    <path d="m13 27 13-15h28l13 15-27 40Z" fill="none" stroke="#93ffad" strokeOpacity=".55" strokeWidth=".8" />
    <path d="m23 16 3-5 3 5 5 2-5 2-3 5-3-5-5-2Z" fill="#ddffe5" />
  </svg>;
}
export function MineArt() {
  return <svg className="art" viewBox="0 0 80 80" aria-hidden="true">
    <g stroke="#ef7380" strokeWidth="5" strokeLinecap="round"><path d="M40 9v12m0 38v12M9 40h12m38 0h12M18 18l9 9m26 26 9 9M18 62l9-9m26-26 9-9" /></g>
    <circle cx="40" cy="40" r="22" fill="#c54656" /><circle cx="38" cy="37" r="17" fill="#ec6878" />
    <path d="M27 34a13 13 0 0 1 12-10" fill="none" stroke="#ffb4bd" strokeWidth="4" strokeLinecap="round" /><circle cx="47" cy="48" r="3" fill="#a73142" />
  </svg>;
}
export function GameIcon({ name, size = 18 }) {
  const paths = {
    gem: <><path d="m12 3 8 5-8 13L4 8l8-5Z" /><path d="M4 8h16M8 4.9 12 8l4-3.1M12 8v13" /></>,
    /* minesmark — the game's identity mark: a 3×3 board (the tiles) with a gem in the
       centre cell. Distinct from the generic `gem` (used for the gems-left counter) and
       from the spiky `mine`. Used only for the Mines page title badge. */
    minesmark: <><rect x="3" y="3" width="18" height="18" rx="4" /><path d="M9 3v18M15 3v18M3 9h18M3 15h18" strokeOpacity=".4" /><path d="m12 9.3 2.4 2.7-2.4 2.7-2.4-2.7Z" fill="currentColor" stroke="none" /></>,
    mine: <><circle cx="12" cy="12" r="6" /><path d="M12 2v3m0 14v3M2 12h3m14 0h3M5 5l2 2m10 10 2 2M5 19l2-2M17 7l2-2" /></>,
    sound: <path d="m11 4-6 5H2v6h3l6 5V4Zm5 4a5 5 0 0 1 0 8m3-11a9 9 0 0 1 0 14" />,
    mute: <path d="m11 4-6 5H2v6h3l6 5V4Zm5 5 6 6m0-6-6 6" />,
    help: <><circle cx="12" cy="12" r="9" /><path d="M9.5 9a2.5 2.5 0 1 1 4 2c-1.2.6-1.5 1-1.5 2.5M12 17h.01" /></>,
    shield: <><path d="m12 3 8 3v6c0 5-8 9-8 9s-8-4-8-9V6l8-3Z" /><path d="m8 12 3 3 5-6" /></>,
    play: <path d="m9 5 10 7-10 7V5Z" fill="currentColor" stroke="none" />,
    arrow: <path d="M4 12h16m-6-6 6 6-6 6" />,
    random: <path d="M3 6h3c5 0 6 12 11 12h4m-4-4 4 4-4 4M3 18h3c2 0 3-2 4-4m3-4c1-2 2-4 4-4h4m-4-4 4 4-4 4" />,
    clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
    lock: <><rect x="5" y="10" width="14" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3" /></>,
    check: <path d="m5 12 4 4L19 6" />,
    back: <path d="m14 5-7 7 7 7M7 12h14" />,
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths[name]}</svg>;
}
